import { HttpClient } from "@angular/common/http";
import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ComponentsTemplatesService } from "./components-templates.service";
import { MediaService } from "src/app/new-media/common/media.service";
import { catchError, debounceTime } from "rxjs";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-components-templates",
  templateUrl: "./components-templates.component.html",
  styleUrls: ["./components-templates.component.css"],
})
export class ComponentsTemplatesComponent implements OnInit {
  constructor(
    private http: HttpClient,
    private modalService: BsModalService,
    private componentsTemplatesService: ComponentsTemplatesService,
    private mediaService: MediaService,
    private snotifyService: ToastrService
  ) {}
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  searchText: string = "";
  dataSource = [];
  tempData: any = {};
  totalRecords = 0; 
  pageSize = 5; 
  currentPage = 0; 
  modalRef: BsModalRef | null;
  componentNames = [];
  pageJson: any;
  isPopupOpen = false; 
  currentImage: string | null = null;
  displayedColumns: string[] = [
    "type",
    "componentName",
    "description",
    "image", 
    "json",
    "action",
  ];
  entityTypes = [
    { name: "Page", value: "PAGE" },
    { name: "Template", value: "TEMPLATE" },
    { name: "Component", value: "COMPONENT" },
    { name: "Row", value: "ROW" }

  ];
  newRow = {
    id: 0,

    name: null,
    description: "",
    index: 0,
    settingsType: "PAGE",
    thumbnailUrl: "",
    settings: "",
    fileName: "",
    isEditing: true,
  };
  getData = {
    pagination: {
      start: this.currentPage,
      number: this.pageSize,
    },
    search: {
      name: "",
      description: "",

      settingsType: "",
      thumbnailUrl: "",
      settings: "",
      fullSearch: "",
    },
  };
  ngOnInit(): void {
    this.getAllTemplate(this.getData);
    this.getAllComponents();
  }


  openPopup(imageUrl: string): void {
    this.isPopupOpen = true;
    this.currentImage = imageUrl;
  }

  closePopup(): void {
    this.isPopupOpen = false;
    this.currentImage = null;
  }
  getAllComponents() {
    this.componentsTemplatesService.getAllComponents().subscribe((res: any) => {
      this.componentNames = res
        .map((el) => {
          return el.components.map((el2) => {
            return { name: el2.name, dataKey: el2.dataKey };
          });
        })
        .flat();
    });
  }
  delete(element) {
    if (element.id == 0) {
      this.dataSource = this.dataSource.filter(
        (el) => el.index != element.index
      );
    } else {
      this.componentsTemplatesService
        .deleteTemplate(element.id)
        .pipe(
          catchError((err) => {
            this.openNotifyFailed(err.message);
            throw err;
          })
        )
        .subscribe((res: any) => {
          this.getAllTemplate(this.getData);
          this.openNotifySuccess("Deleted Successfully");
        });
    }
  }
  getAllTemplate(data) {
    this.componentsTemplatesService
      .getAllTemplates(this.getData)
      .subscribe((res: any) => {
        this.dataSource = res.data;
        this.totalRecords = res.totalCount;
      });
  }

  addRow(): void {
    this.newRow.index++;
    this.dataSource = [{ ...this.newRow }, ...this.dataSource];
  }

  editRow(element: any): void {
    element.isEditing = true;
  }

  saveRow(element: any): void {
    if (!element.settings) {
      this.openNotifyFailed("JSON file is required.");
      return
    }
  
    // Validate if name is required when type is 'component'
    if (element.settingsType.toLowerCase() == "component" && (!element.name)) {
      this.openNotifyFailed("Name is required for components.");
      return
    }
    element.isEditing = false;
    let url;
    url = element.id
      ? this.componentsTemplatesService.updateTemplate( element)
      : this.componentsTemplatesService.addTemplate(element);
    url
      .pipe(
        catchError((err) => {
          this.openNotifyFailed(err.message);
          throw err;
        })
      )
      .subscribe((res: any) => {
        this.getAllTemplate(this.getData)
        this.openNotifySuccess(
          element.id ? "Updated Successfully" : "Added Successfully"
        );
      });
  }

  cancelEdit(element: any): void {
    if (element.index) {
      this.dataSource = this.dataSource.filter(
        (el) => el.index != element.index
      );
    }
    element.isEditing = false;
  }
  openCode(template, data) {
    this.tempData = data;
    this.pageJson = JSON.stringify(JSON.parse(data.settings), null, 1);
    this.modalRef = this.modalService.show(template, { class: " modal-xl" });
  }

  savePageJson() {
    // this.pageLayout = JSON.parse(this.pageJson);
    this.tempData.settings = this.pageJson;
    this.modalRef.hide();
  }

  clonePage(template) {
    this.modalRef = this.modalService.show(template, {
      ignoreBackdropClick: true,
      class: " modal-sm modal-dialog-centered",
    });
  }
  closeModal() {
    this.modalRef.hide();
  }

  onImageUpload(event, element) {
    let formData = new FormData();
    if (event.target.files.length > 0) {
      formData.append("file", event.target.files[0]);

      this.componentsTemplatesService.uploadMedia(formData).subscribe(
        (res: any) => {
          console.log(res);
          
            element.thumbnailUrl = res
          
        },
        (error) => {
          this.openNotifyFailed(error.message);
        }
      );
    }
  }
  onJsonUpload(event: Event, element: any): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      const reader = new FileReader();
      element.fileName = file.name;
      reader.onload = (e) => {
        try {
          const parsedJson = e.target?.result as string;

          element.settings = parsedJson;
        } catch (error) {
          // console.error("Invalid JSON file:", error);
          this.openNotifyFailed("Invalid JSON file: " + error);
        }
      };

      reader.readAsText(file);
    }
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getData.pagination.number = this.pageSize;
    this.getData.pagination.start = this.currentPage;
    this.getAllTemplate(this.getData);
  }
  FilterComponents() {
    this.getData.search.fullSearch = this.searchText;
    this.getAllTemplate(this.getData);
  }
  openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }
  openNotifyFailed(message: string) {
    this.snotifyService.error("", message, {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }
}
